/*
 * @Author: your name
 * @Date: 2021-11-24 11:50:28
 * @LastEditTime: 2021-11-29 17:40:08
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/services/demandService.js
 */
 
import request from '@/utils/request'
import API from '@/apis/api-types'

export function getSearchDemandList (req){
  return request({
    method: 'post',
    url: API.getSearchDemandList,
    data: req
  })
}

export function getDemandDetail (demandId) {
  return request({
    method: 'get',
    url: API.getDemandDetail,
    params: {demandId}
  })
}

export function getRecommendDemandList () {
  return request({
    method: 'post',
    url: API.getRecommendDemandList,
    // params: {}
  })
}